import { calculateHeatPumpFlowRate, evaluateGlycolProtection } from '../../utils/plumbing/g3Calculations';

export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      installerDetails = {},
      siteDetails = {},
      equipmentSpecification = {},
      designParameters = {},
      waterQualityAndAntifreeze = {},
      commissioningMeasurements = {},
      electricalAndControls = {},
      handoverAndDeclarations = {}
    } = formData;

    // 1. Installer validation
    if (!installerDetails.companyName?.trim()) {
      errors['installerDetails.companyName'] = 'Company name is required';
    }
    if (!installerDetails.mcsNumber?.trim()) {
      errors['installerDetails.mcsNumber'] = 'MCS certificate number is required';
    }
    if (!installerDetails.engineerName?.trim()) {
      errors['installerDetails.engineerName'] = 'Lead engineer name is required';
    }

    // 2. Site validation
    if (!siteDetails.clientName?.trim()) {
      errors['siteDetails.clientName'] = 'Client name is required';
    }
    if (!siteDetails.installationAddress?.trim()) {
      errors['siteDetails.installationAddress'] = 'Installation address is required';
    }
    if (!siteDetails.postCode?.trim()) {
      errors['siteDetails.postCode'] = 'Postcode is required';
    }

    // 3. Equipment validation
    if (!equipmentSpecification.hpManufacturer?.trim()) {
      errors['equipmentSpecification.hpManufacturer'] = 'Heat pump manufacturer is required';
    }
    if (!equipmentSpecification.hpModel?.trim()) {
      errors['equipmentSpecification.hpModel'] = 'Heat pump model is required';
    }
    if (!equipmentSpecification.hpSerialNumber?.trim()) {
      errors['equipmentSpecification.hpSerialNumber'] = 'Serial number is required';
    }

    // 4. Design & Flow Rate Checks (MCS MIS 3005)
    const heatLoss = Number(designParameters.designHeatLossKw) || 0;
    const deltaT = Number(designParameters.designDeltaTC) || 5;
    const glycolPct = Number(waterQualityAndAntifreeze.glycolConcentrationPct) || 25;

    if (heatLoss <= 0) {
      errors['designParameters.designHeatLossKw'] = 'Design heat loss must be greater than 0 kW';
    }

    const calculated = calculateHeatPumpFlowRate(heatLoss, deltaT, glycolPct);
    const measuredFlow = Number(commissioningMeasurements.measuredFlowRateLpm) || 0;

    if (measuredFlow > 0 && calculated.flowRateLpm > 0) {
      const flowDeficitPct = ((calculated.flowRateLpm - measuredFlow) / calculated.flowRateLpm) * 100;
      if (flowDeficitPct > 15) {
        warnings['commissioningMeasurements.measuredFlowRateLpm'] = 
          `Measured flow (${measuredFlow} L/min) is ${flowDeficitPct.toFixed(1)}% below MCS design target (${calculated.flowRateLpm} L/min). Check pump speed or pipe sizing.`;
      }
    }

    // 5. Glycol / Antifreeze verification
    const glycolEval = evaluateGlycolProtection(glycolPct, false);
    if (!glycolEval.isSatisfactory) {
      warnings['waterQualityAndAntifreeze.glycolConcentrationPct'] = glycolEval.recommendation;
    }

    const ph = Number(waterQualityAndAntifreeze.primaryWaterPh);
    if (ph && (ph < 7.5 || ph > 9.5)) {
      warnings['waterQualityAndAntifreeze.primaryWaterPh'] = `System pH of ${ph} is outside ideal range (7.5 - 9.5). Inhibitor buffering recommended.`;
    }

    // 6. Signatures
    if (!handoverAndDeclarations.engineerSignature) {
      errors['handoverAndDeclarations.engineerSignature'] = 'Engineer signature is required';
    }
    if (!handoverAndDeclarations.customerSignature) {
      warnings['handoverAndDeclarations.customerSignature'] = 'Client signature is recommended for statutory handover';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
